import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import ProcessSection from '../components/ProcessSection';
import Benefits from '../components/Benefits';
import Stats from '../components/Stats';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ProcessSection />
      <Benefits />
      {/* <Stats /> */}
      <CTA />
      <Footer />
    </div>
  );
};

export default Home;